module.exports = __webpack_public_path__ + "img/s3-4.317eb00b.jpg";